import Vue from 'vue'
import VueTippy, { TippyComponent } from 'vue-tippy'

Vue.use(VueTippy, {
  animation: 'fade'
})
Vue.component('Tippy', TippyComponent)
